import React, { FC, useEffect, useMemo } from "react"
import { observer } from "mobx-react-lite"
import { Appearance, ViewStyle } from "react-native"
import { JalaLoading, JalaWebView, LazyRender, Screen } from "../../../../components"
import { color } from "../../../../theme"
import { CompositeScreenProps } from "@react-navigation/native"
import { useStores } from "../../../../models"
import config from "../../../../utils/config"
import { goBack } from "../../../../navigators"
import { View } from "native-base"

const ROOT: ViewStyle = {
  flex: 1,
}

const WEB_VIEW: ViewStyle = {
  flexGrow: 1,
}

const LoadingState: FC<{ colorScheme: "light"|"dark" }> = function(props) {
  return (
    <View flex={1} px="16px" justifyContent="center" alignItems="center">
      <JalaLoading />
    </View>
  )
}

export const CycleGraphScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function CycleGraphScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props;

  // Pull in one of our MST stores
  const {
    appStore: { farmStore: { pondStore } }
  } = useStores();

  useEffect(() => {
    if (!pondStore.cycleId)
      goBack('Home.Stack');
  }, [pondStore.cycleId])

  const source = useMemo(() => {
    const { BASE_URL } = config()

    return {
      uri: `${BASE_URL}/web_view/cycles/${pondStore.cycleId || ''}/charts`
    }
  }, [pondStore.cycleId])

  return (
    <Screen
      style={ROOT}
      preset="fixed"
      unsafe
      colorScheme={colorScheme}
      backgroundBar={colorScheme === 'light' ? color.primary : undefined}
      statusBar={colorScheme === 'light' ? 'light-content' : 'dark-content'}
    >
      <LazyRender renderPlaceholder={LoadingState}>
        {source && <JalaWebView
          source={source}
          style={WEB_VIEW}
          startInLoadingState
        />}
      </LazyRender>
    </Screen>
  )
})
